<template>
  <div class="container-leftmenu">
    <div class="collapse-wrap">
      <el-button
        class="collapse-btn"
        size="mini"
        :icon="collIcon"
        @click="changeColl"
      ></el-button>
    </div>
    <el-menu
      :default-active="activePath"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      router
    >
      <el-menu-item :index="'/bindex?userId='+userId">
        <i class="el-icon-menu"></i>
        <span slot="title">BSC首页</span>
      </el-menu-item>
      <el-menu-item :index="'/bcompanyIndicators?userId='+userId">
        <i class="el-icon-document"></i>
        <span slot="title">公司指标</span>
      </el-menu-item>
      <el-menu-item :index="'/borganizationalIndicators?userId='+userId">
        <i class="el-icon-setting"></i>
        <span slot="title">组织指标</span>
      </el-menu-item>
      <el-menu-item :index="'/bjobIndicators?userId='+userId">
        <i class="el-icon-setting"></i>
        <span slot="title">岗位指标</span>
      </el-menu-item>
      <el-menu-item :index="'/btastIndicators?userId='+userId">
        <i class="el-icon-setting"></i>
        <span slot="title">任务指标</span>
      </el-menu-item>
      <!-- <el-submenu index="1-4">
        <template slot="title"><i class="el-icon-document"></i><span slot="title">任务管理</span></template>
        <el-menu-item index="creatTask"><i class="el-icon-tickets"></i><span slot="title">我的任务</span></el-menu-item>
        <el-menu-item index="rewardHall"><i class="el-icon-setting"></i><span slot="title">悬赏大厅</span></el-menu-item>
      </el-submenu>
      <el-submenu index="1-5">
        <template slot="title"><i class="el-icon-coin"></i><span slot="title">积分管理</span></template>
        <el-menu-item index="budgetCustomization"><i class="el-icon-setting"></i><span slot="title">预算定制</span></el-menu-item>
        <el-menu-item index="integralDistribution"><i class="el-icon-s-marketing"></i><span slot="title">积分分配</span></el-menu-item>
        <el-menu-item index="integralCenter"><i class="el-icon-setting"></i><span slot="title">积分中心</span></el-menu-item>
      </el-submenu> -->
      <!-- <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>后台管理</span>
        </template>
        <el-submenu index="1-4">
          <template slot="title">任务管理</template>
          <el-menu-item index="creatTask">我的任务</el-menu-item>
          <el-menu-item index="rewardHall">悬赏大厅</el-menu-item>
        </el-submenu>
        <el-submenu index="1-5">
          <template slot="title">积分管理</template>
          <el-menu-item index="budgetCustomization">预算定制</el-menu-item>
          <el-menu-item index="integralDistribution">积分分配</el-menu-item>
          <el-menu-item index="integralCenter">积分中心</el-menu-item>
        </el-submenu>
      </el-submenu> -->
    </el-menu>
  </div>
</template>

<script>
import { onMounted, reactive, ref, inject, getCurrentInstance } from '@vue/composition-api'
export default {
  name: 'LeftMenu',
  props: [],
  setup () {
    let userId = inject('userId')
    let isCollapse = ref(false)
    let vm = getCurrentInstance()
    let activePath = ref('')
    activePath.value = vm.proxy.$route.path + '?userId=' + userId
    onMounted(() => {
      console.log(userId)
    })
    function handleOpen (key, keyPath) {
      console.log(key, keyPath)
    }
    function handleClose (key, keyPath) {
      console.log(key, keyPath)
      collIcon.value = 'el-icon-d-arrow-right'
    }
    let collIcon = ref('el-icon-d-arrow-left')

    let changeColl = function () {
      isCollapse.value = !isCollapse.value
      collIcon.value = isCollapse.value ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'
    }
    return {
      userId,
      changeColl,
      collIcon,
      isCollapse,
      handleClose,
      handleOpen,
      activePath
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

.collapse-wrap
  text-align: right

.container-leftmenu
  overflow-y auto
  height: 100%;
  overflow-x hidden

  >>> .el-icon-s-fold
        font-size: 16px
      .collapse-btn
        padding: 0 0
        border none
        font-size: 28px
        font-weight: bolder
</style>
